import { parseJSON, showErrorsAtTop } from "./helpers";

export function showSelectedFile() {
  const $inputs = $(".js-file-upload");

  if ($inputs.length > 0) {
    $inputs.each(function () {
      const $input = $(this);
      const $dropZoneEl = $input.closest(".upload-file-container");

      $input.on("change", function (e) {
        const $uploadContainer = $(this).closest(".upload-file-container");
        const file = $(this).prop("files");
        if (file.length > 0) {
          createSelectedFileInfo(file[0], $uploadContainer);
          $(this).valid();
        }
      });

      // handle drag and drop
      $dropZoneEl
        .on("dragover", function (e) {
          e.preventDefault();
          $(this).addClass("drop-zone--over");
        })
        .on("drop", function (e) {
          e.preventDefault();
          const dt = e.originalEvent.dataTransfer;

          if (dt.files.length > 0) {
            const file = dt.files[0];
            $input[0].files = dt.files;
            // remove trigger("change") and call createSelectedFileInfo directly
            createSelectedFileInfo(file, $(this));
            $input.valid();
          }
          $(this).removeClass("drop-zone--over");
        })
        .on("dragleave dragend", function () {
          $(this).removeClass("drop-zone--over");
        });
    });
  }
}

function genFileList(name, size) {
  const $template = $(".js-file-info-tmpl");
  const $clone = $($template.prop("content")).clone();
  $clone.find(".js-file-name-op").text(name);
  $clone.find(".js-file-size-op").text(`${size} Megabytes`);

  return $clone;
}

function createSelectedFileInfo(fileObj, $uploadContainer, isBytes = true) {
  const { name, size } = fileObj || {};
  let sizeInMb = 0;

  isBytes ? (sizeInMb = convertToMb(size)) : (sizeInMb = size);

  if (name) {
    const $fileContentHtml = genFileList(name, sizeInMb);
    clearPreviousEntries($uploadContainer);
    $fileContentHtml.insertAfter($uploadContainer);
  } else {
    clearPreviousEntries($uploadContainer);
  }
}

function convertToMb(size) {
  const fileSizeBytes = size;
  const fileSizeMb = fileSizeBytes / 1024 ** 2;
  return fileSizeMb.toFixed(2);
}

function clearPreviousEntries($uploadContainer) {
  const $fileUploadWrapper = $uploadContainer.closest(
    ".js-file-upload-wrapper"
  );
  const $fileInfoBlock = $fileUploadWrapper.find(".js-file-info-block");
  $fileInfoBlock.remove();
}

function remFileInfoBlock($el) {
  const $parentBlock = $el.closest(".js-file-upload-wrapper");
  $parentBlock.find(".js-file-upload").val("");
  $parentBlock.find(".js-file-info-block").remove();
}

export function deleteSuuportingDocs() {
  $(document).on("click", ".js-remove-file", function (e) {
    e.preventDefault();
    const $hiddenUploadedFileInfo = $(".js-hidden-uploaded-file-info");
    const fileInfoJsonObj = parseJSON($hiddenUploadedFileInfo.val());

    if (fileInfoJsonObj.name) {
      deleteFileFromDB($(this));
      $hiddenUploadedFileInfo.val("");
    } else {
      remFileInfoBlock($(this));
    }
  });
}

async function deleteFileFromDB($el) {
  let refVal = $(".js-ref-id").val();
  const methodURL = `/Application/DeleteUpload?id=${refVal}`;

  try {
    const response = await $.ajax({
      url: methodURL,
      method: "POST",
      data: refVal,
    });

    if (response.success) {
      remFileInfoBlock($el);
    } else {
      showErrorsAtTop(response.message);
    }
  } catch (err) {
    console.log(err);
  }
}

export function showUploadedFile() {
  const fileInfoHiddenFieldVal = $(".js-hidden-uploaded-file-info").val();
  if (!fileInfoHiddenFieldVal) return;

  let fileInfoObj;

  try {
    fileInfoObj = parseJSON(fileInfoHiddenFieldVal);
  } catch (e) {
    console.warn("Invalid JSON in hidden file info:", e);
    return;
  }

  if (fileInfoObj && fileInfoObj.name) {
    const $container = $(".upload-file-container");
    createSelectedFileInfo(fileInfoObj, $container, false);
  }
}
